import { render, staticRenderFns } from "./BookmarksDialog.vue?vue&type=template&id=fe3b6f92&scoped=true"
import script from "@/components/BookmarkWidget/BookmarksDialog/BookmarksDialog.ts?vue&type=script&lang=ts&external"
export * from "@/components/BookmarkWidget/BookmarksDialog/BookmarksDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/BookmarkWidget/BookmarksDialog/bookmarks-dialog.scss?vue&type=style&index=0&id=fe3b6f92&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3b6f92",
  null
  
)

export default component.exports